/* Pristine Magnesium Oil PDP.
   Adapted from product-sleep-cream-seal.js. Same Seal-widget proxying, but this
   product is a single SKU with one plan, so there is no jar selector: the expected
   selling plan id lives on the root as data-scp-selling-plan-id. */
(function () {
  var syncing = false;

  function getPurchaseMode(root) {
    var checked = root.querySelector('[data-scp-mode]:checked');
    return checked ? checked.value : 'once';
  }

  function updatePurchaseCards(root, mode) {
    var subscribeCard = root.querySelector('[data-scp-subscribe-card]');
    var onceCard = root.querySelector('[data-scp-once-card]');
    if (subscribeCard) subscribeCard.classList.toggle('is-selected', mode === 'subscribe');
    if (onceCard) onceCard.classList.toggle('is-selected', mode === 'once');
    root.dataset.mode = mode;
  }

  function numericPlanId(value) {
    if (value === null || value === undefined) return '';
    return String(value).split('/').pop() || '';
  }

  function getExpectedPlanId(root) {
    var raw = root.getAttribute('data-scp-selling-plan-id');
    if (raw === null || raw === '') return null; // no plan wired up yet -> one-time only
    return numericPlanId(raw);
  }

  function getSealOptions(root) {
    var container = root.querySelector('.sls-purchase-options-container');
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('input.sls-option'));
  }

  function isSealRadioReady(radio) {
    if (!radio) return false;
    var container = radio.closest('.sls-option-container');
    return Boolean(container && !container.classList.contains('sls-disabled-option-container'));
  }

  function findSealOptionByPlanId(root, planId) {
    var options = getSealOptions(root);
    for (var i = 0; i < options.length; i++) {
      var container = options[i].closest('.sls-option-container');
      var select = container ? container.querySelector('select[name="subs_interval"]') : null;
      if (select && numericPlanId(select.value) === planId) return options[i];
    }
    return null;
  }

  function findSealOneTimeOption(root) {
    var options = getSealOptions(root);
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-type') === 'one_time' || options[i].value === 'one_time') {
        return options[i];
      }
    }
    return options[0] || null;
  }

  function syncSellingPlanFromSeal(root, radio) {
    var planInput = root.querySelector('input[name="selling_plan"]');
    if (!planInput || !radio) return;

    if (radio.getAttribute('data-type') === 'one_time' || radio.value === 'one_time') {
      planInput.value = '';
      return;
    }

    var container = radio.closest('.sls-option-container');
    var select = container ? container.querySelector('select[name="subs_interval"]') : null;
    if (select && select.value) planInput.value = select.value;
  }

  function selectSealOptionRadio(root, radio) {
    if (!radio) return false;

    if (radio.checked) {
      syncSellingPlanFromSeal(root, radio);
      return true;
    }

    syncing = true;

    var clickable = radio.closest('[role="radio"]') || radio.parentElement || radio;
    clickable.click();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSellingPlanFromSeal(root, radio);
    syncing = false;
    return radio.checked;
  }

  function syncAll(root) {
    var form = root.querySelector('.scp-form');
    if (!form) return false;

    var mode = getPurchaseMode(root);
    var sealOptions = getSealOptions(root);
    if (!sealOptions.length) return false;

    if (mode === 'once') {
      // Never let a stale plan ride along on a one-time purchase.
      var planInput = root.querySelector('input[name="selling_plan"]');
      if (planInput) planInput.value = '';
      var oneTime = findSealOneTimeOption(root);
      if (!oneTime) return true; // widget odd: one-time stays purchasable
      if (!isSealRadioReady(oneTime)) return false;
      return selectSealOptionRadio(root, oneTime);
    }

    // Subscribe: match ONLY this product's own plan. Never fall back to option order.
    var expected = getExpectedPlanId(root);
    if (!expected) return false;
    var match = findSealOptionByPlanId(root, expected);
    if (!match || !isSealRadioReady(match)) return false;
    return selectSealOptionRadio(root, match);
  }

  function waitForWidgetAndSync(root, attempts) {
    if (syncAll(root)) return;
    if (attempts > 0) {
      window.setTimeout(function () {
        waitForWidgetAndSync(root, attempts - 1);
      }, 250);
    }
  }

  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-scp-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-scp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-scp-thumb]'));
    var current = root.querySelector('[data-scp-current]');
    var progress = root.querySelector('[data-scp-progress]');
    var prev = root.querySelector('[data-scp-gallery-prev]');
    var next = root.querySelector('[data-scp-gallery-next]');
    var active = 0;

    function setActive(index, scroll) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === active);
      });
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === active);
      });
      if (current) current.textContent = String(active + 1);
      if (progress) progress.style.width = ((active + 1) / Math.max(1, slides.length) * 100) + '%';
      if (scroll && slides[active]) slides[active].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index, true);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        if (!slides.length) return;
        setActive((active - 1 + slides.length) % slides.length, false);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (!slides.length) return;
        setActive((active + 1) % slides.length, false);
      });
    }

    if (slidesWrap) {
      var ticking = false;
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      slidesWrap.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesWrap.scrollLeft;
        slidesWrap.classList.add('is-dragging');
        if (slidesWrap.setPointerCapture) slidesWrap.setPointerCapture(event.pointerId);
      });

      slidesWrap.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        slidesWrap.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        slidesWrap.classList.remove('is-dragging');
        if (slidesWrap.releasePointerCapture) {
          try {
            slidesWrap.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      slidesWrap.addEventListener('pointerup', endDrag);
      slidesWrap.addEventListener('pointercancel', endDrag);
      slidesWrap.addEventListener('pointerleave', endDrag);
      slidesWrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          if (!slides.length) {
            ticking = false;
            return;
          }
          var width = slides[0].getBoundingClientRect().width + 8;
          setActive(Math.round(slidesWrap.scrollLeft / width), false);
          ticking = false;
        });
      }, { passive: true });
    }
  }

  function initAccordions(root) {
    var details = Array.prototype.slice.call(root.querySelectorAll('.scp-accordions details'));
    details.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        details.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initSubscribeModal(root) {
    var trigger = root.querySelector('[data-scp-sub-info]');
    var modal = root.querySelector('[data-scp-sub-modal]');
    if (!trigger || !modal) return;
    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-scp-modal-close]'));
    var lastFocus = null;

    function openModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('scp-modal-open');
      var close = modal.querySelector('[data-scp-modal-close]');
      if (close) close.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('scp-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') openModal(event);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initRoot(root) {
    initGallery(root);
    initAccordions(root);
    initSubscribeModal(root);

    var form = root.querySelector('.scp-form');
    if (!form) return;

    root.addEventListener('change', function (event) {
      if (syncing) return;
      if (event.target.matches('[data-scp-mode]')) {
        updatePurchaseCards(root, event.target.value);
        waitForWidgetAndSync(root, 8);
      }
    });

    updatePurchaseCards(root, getPurchaseMode(root));
    waitForWidgetAndSync(root, 12);

    /* Submit guard, CAPTURE phase on document: the form sits inside Dawn's <product-form>
       custom element, whose own submit listener preventDefaults and performs an AJAX add —
       so a listener on the form itself runs too late to stop it. */
    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;

      syncAll(root);

      var mode = getPurchaseMode(root);
      var planInput = form.querySelector('input[name="selling_plan"]');

      if (mode === 'once') {
        // One-time must never submit a plan — and stays purchasable even if Seal is absent.
        if (planInput) planInput.value = '';
        return;
      }

      var expected = getExpectedPlanId(root);
      if (expected === null) return; // no plan configured: nothing to guard

      var actual = planInput ? numericPlanId(planInput.value) : '';
      if (!expected || actual !== expected) {
        event.preventDefault();
        event.stopPropagation();
        if (window.console && console.error) {
          console.error('PDP subscribe guard: expected plan ' + expected + ', got "' + actual + '"');
        }
        window.alert('Sorry, the subscription option is temporarily unavailable. Please try again in a moment or choose one-time purchase.');
      }
    }, true);

    var observer = new MutationObserver(function () {
      if (root.querySelector('.sls-purchase-options-container')) waitForWidgetAndSync(root, 4);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.scp-root--single')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
